module.exports = "<p>You've been logged out. Please login to continue your session.</p>\n<hr>\n<div class=\"row\">\n    <div class=\"pull-right\">\n        <div class=\"button-form col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary right\" (click)=\"login()\">\n                <span>Login</span>\n            </button>\n            <button type=\"button\" style=\"margin-right: 15px;\" class=\"btn btn-default right\" (click)=\"logout()\">\n                <span>Logout</span>\n            </button>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/login-prompt/login-prompt.component.html
// module id = 900
// module chunks = 0